import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import useNear from "../hooks/nearHook";
import useSbt from "../hooks/sbtHook";
import useSbtPermissions from "../hooks/sbtPermissionsHook";
import useSbtMarketplace from "../hooks/sbtMarketplaceHook";
import useTokenRouting from "../hooks/tokenRoutingHook";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import ReactJson from "react-json-view";
import SbtMetadataTable from "../components/SbtMetadataTable";
import SbtSelector from "../components/SbtSelector";
import SbtTokenListTable from "../components/SbtTokenListTable";
import AccountField from "../components/AccountField";
import SbtPermissionSelector from "../components/SbtPermissionSelector";
import IconButton from "@mui/material/IconButton";
import AddBoxIcon from "@mui/icons-material/AddBox";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import { useNavigate } from "react-router-dom";
import { utils } from "near-api-js";

const MarketplaceOfferDashboard = ({}) => {
  const near = useNear();
  const perms = useSbtPermissions();
  const marketplace = useSbtMarketplace();

  const [marketplaceListings, setMarketplaceListings] = useState([]);
  const [sbtPermsMetadata, setSbtPermsMetadata] = useState({});
  const {
    contractId,
    accountId,
    selectedTokenId,
    setContractId,
    setAccountId,
    setSelectedTokenId,
  } = useTokenRouting();
  const [price, setPrice] = useState("");

  useEffect(() => {
    setAccountId(near.account.account);
  }, [accountId, near.account.account]);

  useEffect(() => {
    if (!contractId || !near.account.account) {
      setMarketplaceListings([]);
      return;
    }
    marketplace.getListings(contractId).then((result) => {
      setMarketplaceListings(result);

      setSelectedTokenId(null);
    });
  }, [contractId, near.account.account]);

  useEffect(() => {
    if (!contractId || !near.account.account) {
      setSbtPermsMetadata({});
      return;
    }
    perms.getContractMetadata(contractId).then(setSbtPermsMetadata);
  }, [contractId, near.account.account]);

  const makeOffer = () => {
    if(!selectedTokenId || !contractId){
      return;
    }
    console.log("Add offer", contractId, selectedTokenId, price);
    marketplace.addOffer(contractId, selectedTokenId, price);
  }

  const disabled = !selectedTokenId;
  const selectedListing = marketplaceListings.find(l => l.id == selectedTokenId);
  
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 450,
            }}
          >
            <SbtPermissionSelector
              sbtAuthContractId={contractId}
              setSbtAuthContractId={setContractId}
            />
            <SbtMetadataTable sbtMetadata={sbtPermsMetadata} />
          </Paper>
        </Grid>
        <Grid item xs={12} md={7}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 420,
            }}
          >
            <SbtTokenListTable
              sbtTokens={marketplaceListings}
              onSelect={setSelectedTokenId}
              title="Listings"
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={5}>
          <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 420,
            }}
          >
            <ReactJson
              src={selectedListing || {}}
              name={false}
              style={{ overflow: "auto" }}
              enableClipboard={false}
            />
          </Paper>
        </Grid>
        <Grid item xs={12} md={7}>
        <Paper
            sx={{
              p: 2,
              display: "flex",
              flexDirection: "column",
              height: 420,
            }}
          >
            {selectedListing?.price 
                ? `Min price: ${utils.format.formatNearAmount(selectedListing.price.toString())}N`
                : "No min price"}
            <TextField 
              type="number"
              label="Offer price"
              value={price}
              onChange={e => setPrice(e.target.value)}
              disabled={disabled}
            />
            <Button variant="contained" onClick={makeOffer} disabled={disabled}>
              Make offer
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default MarketplaceOfferDashboard;
